import { render, staticRenderFns } from "./EditEvidence.vue?vue&type=template&id=58ed1a1e&scoped=true"
import script from "./EditEvidence.vue?vue&type=script&lang=js"
export * from "./EditEvidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ed1a1e",
  null
  
)

export default component.exports